import React, { useEffect, useState } from 'react';
import { Table } from 'tea-component';
import { SortByItemType } from '@/pages/intelligence/components/TableComponents/components/SortBy';
import { sortTableByMetric } from '@/pages/intelligence/utils/tableUtils';
import { MetricsTableCloums } from '@/pages/intelligence/pages/TopCharts/_config/TableCloums/MetricsTableCloums';
import useIntlExtend from '@/pages/intelligence/hooks/useIntlExtend';
import { DateColumns } from '@/pages/intelligence/pages/TopCharts/_config/TableCloums/DateCloums';
import { useIntl } from 'umi';
const { pageable, scrollable } = Table.addons;
const getMetricValueOfCvm = (cvm: any, metricKey: string) => {
  if (!cvm || !metricKey) {
    return {};
  }
  return { growth_ratio: cvm?.dod, value: cvm?.value };
};

const TrendsCard = (props: any) => {
  const {
    tableData = [],
    pageId,
    dateType,
    pageSortAttr: defaultPageSortAttr,
    columnsList,
    entityType = ''
  } = props;

  const { formatMessage } = useIntlExtend();
  const [sortTableData, setSortTableData] = useState(tableData);
  const [pageSortAttr, setPageSortAttr] = useState({
    currentSortValue: 'desc',
    currentSortMetric: 'date',
    currentRatioType: 0,
  });

  const {
    // tablePageIndex,
    // tablePageSize,
    currentSortValue,
    currentSortMetric,
    currentRatioType,
  } = pageSortAttr || {};

  useEffect(() => {
    onSortChage({
      sortMetric: currentSortMetric,
      sortVal: 'desc',
      ratioType: 0,
    });
  }, [JSON.stringify(tableData), defaultPageSortAttr]);

  const onSortChage = (e: SortByItemType) => {
    setPageSortAttr({
      currentSortValue: e.sortVal,
      currentSortMetric: e.sortMetric,
      currentRatioType: e.ratioType,
    });
    const sortTable = sortTableByMetric({
      tableData: tableData,
      sortParams: e,
      growthProperty: 'dod',
      getMetricValueFun: (cvm) => {
        return cvm;
      },
    });
    setSortTableData(sortTable.slice(0));
  };

  const getMetricCloums = () => {
    const metricCloums: any[] = [];
    // const titles = getPCConsoleCloumsByPageId(pageId);
    columnsList?.forEach((t) => {
      metricCloums.push(
        MetricsTableCloums({
          /**MetricsTable页只有降序功能 */
          onlySimpleSort: false,
          renderType: t?.renderType,
          width: t?.width,
          width_cn: t?.width_cn,
          dataSource: t?.dataSource, //source === 'ogdb' ? 'databarin' : source,
          title: t?.text,
          textContent: t?.info,
          tipText: t?.iconInfo,
          key: `${t?.value}`,
          sortMetric: t?.value,
          currentSortValue: currentSortValue,
          currentSortKey: `${currentSortMetric}_${currentRatioType}`,
          onSortChage: onSortChage,
          dateType: dateType,
          pageId: pageId,
          getMetricValueOfCvm: getMetricValueOfCvm,
          formatMessage,
          entityType
        }),
      );
    });
    return metricCloums;
  };

  return (
    <>
      <Table
        bordered="all"
        records={sortTableData}
        className="dbi-mobileGames-details-table"
        columns={[
          DateColumns({
            key: 'date',
            sortMetric: 'date',
            title: formatMessage({ id: `dbi_date` }),
            currentSortMetric: currentSortMetric,
            currentSortValue: currentSortValue,
            dateType: dateType,
            onSortChage,
            width: 180,
          }),
          ...getMetricCloums(),
        ]}
        addons={[
          pageable({
            stateTextVisible: true,
            pageSizeVisible: sortTableData?.length > 5,
            pageIndexVisible: sortTableData?.length > 5,
            jumpVisible: sortTableData?.length > 5,
            endJumpVisible: sortTableData?.length > 5,
            pageSizeOptions: [5, 10, 15],
            stateText: formatMessage(
              { id: 'dbi_pagination_total' },
              { total: sortTableData?.length ?? 0 },
            ),
          }),
        ]}
      />
    </>
  );
};

export default TrendsCard;
